import React from "react";

const AdsTerms = () => {
  return (
    <>
      <p>
        <strong>Advertising Terms and Conditions</strong>
      </p>
      <p>
        <strong>1. Binding Agreement</strong>
      </p>
      <p>
        By submitting an advertisement for publication on the{" "}
        <strong>EstateIQ Platform</strong>, you acknowledge that you have read,
        understood, and agree to be legally bound by these Advertising Terms and
        Conditions. 
      </p>
      <p>
        <strong>2. Content Standards and Prohibited Conduct</strong>
      </p>
      <p>
        To maintain the integrity of the Platform, all advertisements must
        adhere to the following standards:
      </p>
      <ul>
        <li>
          <strong>Accuracy:</strong> Advertisements must be truthful,
          non-deceptive, and contain verified pricing and service descriptions.
          Misleading representations are strictly prohibited.
        </li>
        <li>
          <strong>Geographic Relevance:</strong> Advertised services must be
          legally permissible and available to residents within the Platform’s
          operational jurisdiction.
        </li>
        <li>
          <strong>Prohibited Content:</strong> EstateIQ maintains a
          zero-tolerance policy for advertisements involving:
          <ul>
            <li>Controlled substances or illicit drugs.</li>
            <li>
              Gambling, wagering, or unlicensed financial schemes (including
              pyramid/Ponzi schemes).
            </li>
            <li>Adult-oriented content or services.</li>
            <li>Political campaigning or advocacy.</li>
            <li>
              Hate speech, defamatory material, or any content that violates the
              laws of the Federal Republic of Nigeria.
            </li>
          </ul>
        </li>
      </ul>
      <p>
        <strong>3. Placement, Duration, and Visibility</strong>
      </p>
      <ul>
        <li>
          <strong>Ad Placement:</strong> Advertisements shall be displayed
          within the specific banner package selected by the Advertiser at the
          time of purchase.
        </li>
        <li>
          <strong>Rotation and Priority:</strong> Standard advertisements are
          subject to automated rotation. Priority "pinned" placement is
          exclusive to <strong>Premium Tier</strong> packages and is subject to
          availability and specific time-slot allocations.
        </li>
        <li>
          <strong>Term:</strong> The duration of the advertisement's visibility
          is governed by the purchased term (e.g., 30 days or 60 days cycle).
        </li>
      </ul>
      <p>
        <strong>4. Financial Terms</strong>
      </p>
      <ul>
        <li>
          <strong> Pricing:</strong> EstateIQ reserves the right to adjust
          advertising rates at its discretion. However, rates for active,
          pre-paid campaigns shall remain fixed for the duration of the agreed
          term.
        </li>
        <li>
          <strong>Refund Policy:</strong> All fees are non-refundable once an
          advertisement has been approved and successfully deployed on the
          Platform.
        </li>
        <li>
          <strong>Taxation:</strong> All quoted prices are inclusive of Value
          Added Tax (VAT) in accordance with Nigerian fiscal regulations.
        </li>
      </ul>
      <p>
        <strong>5. Intellectual Property and Data Privacy</strong>
      </p>
      <ul>
        <li>
          <strong>License Grant:</strong> The Advertiser grants EstateIQ a
          non-exclusive, royalty-free license to use, display, and reproduce the
          Advertiser’s logos, trademarks, and creative assets solely for the
          purpose of fulfilling the advertising contract.
        </li>
        <li>
          <strong>Brand Protection:</strong> Advertisers are prohibited from
          using the EstateIQ logo, branding, or intellectual property without
          prior written consent.
        </li>
        <li>
          <strong>Data Security:</strong> In compliance with the Nigeria Data
          Protection Act (NDPA), EstateIQ does not share personal resident data
          with third-party advertisers.
        </li>
      </ul>
      <p>
        <strong>6. Disclaimers and Indemnification</strong>
      </p>
      <ul>
        <li>
          <strong>No Guarantee of Performance:</strong> While EstateIQ
          facilitates visibility to a targeted user base, it provides no
          warranty regarding conversion rates, sales volumes, or specific
          commercial outcomes.
        </li>
        <li>
          <strong>Service Continuity:</strong> EstateIQ shall not be liable for
          temporary service interruptions due to scheduled maintenance or
          unforeseen technical force majeure.
        </li>
        <li>
          <strong>Indemnity:</strong> The Advertiser assumes sole liability for
          the quality of services rendered. The Advertiser agrees to indemnify,
          defend, and hold harmless EstateIQ against any third-party claims,
          damages, or legal costs arising from the Advertiser’s products,
          services, or breach of these terms.
        </li>
      </ul>
      <p>
        <strong>7. Termination and Removal</strong>
      </p>
      <p>
        EstateIQ reserves the right to unilaterally remove any advertisement
        without notice or refund under the following circumstances:
      </p>
      <ul>
        <li>
          Receipt of substantiated reports of fraudulent activity or harassment.
        </li>
        <li>Material breach of these Terms and Conditions.</li>
        <li>
          Violation of any applicable local, state, or federal laws of Nigeria.
        </li>
      </ul>
      <p>
        <strong>8. Governing Law and Dispute Resolution</strong>
      </p>
      <p>
        These terms shall be governed by and construed in accordance with the{" "}
        <strong>Laws of the Federal Republic of Nigeria</strong>. In the event
        of a dispute, the parties agree to first attempt an amicable resolution
        through <strong>mediation in Lagos, Nigeria</strong>, prior to
        initiating any formal judicial proceedings.
      </p>
    </>
  );
};

export default AdsTerms;
